import React, { Component } from 'react';
import i18n from 'app/common/i18n';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

function checkValueType(value, defaultValue) {
  return typeof value === 'number'
    ? value
    : typeof defaultValue === 'number'
    ? defaultValue
    : '';
}

class InputCurrency extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: checkValueType(props.value, props.defaultValue)
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      const value = checkValueType(nextProps.value, nextProps.defaultValue);
      this.setState({ value });
    }
  }

  handleChange = (ev) => {
    // TODO: Validate using min/max from props

    const stringValue = ev.target.value.replace(/[^0-9,]/g, '');
    const commaMatch = stringValue.match(/,/g);
    if (commaMatch && commaMatch.length > 1) {
      return;
    }

    const value = stringValue ? Number(stringValue.replace(',', '.')) : '';

    this.setState({ value });

    this.props.onChange({
      target: {
        name: this.props.name,
        value: value,
        type: 'mixed'
      }
    });
  };

  withCurrency(value) {
    if (typeof value === 'number') {
      const number = String(value).split('.');
      return `${number[0]
        .substr(0, 6) // TODO: maxLength should be a prop
        .replace(/^([0-9]{1,3})([0-9]{3})+$/, (m, p1, p2) => `${p1}.${p2}`)}${
        number.length === 2 ? `,${number[1]}` : ''
      }`;
    }
    return value;
  }

  render() {
    const {
      i18n,
      error,
      value, // eslint-disable-line no-unused-vars
      defaultValue, // eslint-disable-line no-unused-vars
      inputProps = {},
      InputProps = {},
      InputLabelProps = {},
      startAdornment,
      endAdornment,
      removeMargin,
      ...props
    } = this.props;

    const nextInputProps = { ...InputProps };

    if (error) {
      props.helperText = i18n(
        typeof error === 'string' ? error : error.message
      );
    }

    if (startAdornment) {
      nextInputProps.startAdornment =
        typeof startAdornment === 'string' ? (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ) : (
          startAdornment
        );
    }
    if (endAdornment) {
      nextInputProps.endAdornment =
        typeof endAdornment === 'string' ? (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ) : (
          endAdornment
        );
    }

    return (
      <TextField
        error={Boolean(error)}
        style={removeMargin ? {} : { marginBottom: 24 }}
        inputProps={{ style: { textAlign: 'right' }, ...inputProps }}
        InputProps={nextInputProps}
        InputLabelProps={{ shrink: true, ...InputLabelProps }}
        {...props}
        type="text"
        value={this.withCurrency(this.state.value)}
        onChange={this.handleChange}
      />
    );
  }
}

export default i18n(InputCurrency);